import { render, staticRenderFns } from "./SetupPaymentForm.vue?vue&type=template&id=3788f04e&"
import script from "./SetupPaymentForm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SetupPaymentForm.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SetupPaymentForm.vue?vue&type=style&index=0&id=3788f04e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports